import { put, select } from 'redux-saga/effects';
import {
  selectContentLibraryOpenedFile,
  selectContentLibraryOpenedFileCurrentPage,
} from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import {
  requestContentWhiteboardData,
  requestScreenshareWhiteboardData,
} from 'features/content-whiteboard/actions';
import { CONTENT_BOARD_SUPPORTED_FILE_TYPES } from 'features/content-whiteboard/constants';
import { selectGridPanel } from 'features/layout/features/content/contentSlice';
import { GridPanelName } from 'features/layout/features/content/types';
import { selectSelectedScreenshare } from 'features/screenshare/screenshareSlice';
import { SelectedScreenshare } from 'features/screenshare/types';
import { requestWhiteboardData } from 'features/whiteboard/actions';

export function* requestActivePanelWhiteboardDataSaga() {
  const currentGridPanel: GridPanelName | null = yield select(selectGridPanel);

  if (currentGridPanel === 'whiteboard') {
    const openedFile: ContentLibraryOpenedFile | null = yield select(
      selectContentLibraryOpenedFile
    );
    if (openedFile) {
      yield put(requestWhiteboardData(openedFile.id));
    }
    return;
  }

  if (currentGridPanel === 'contentLibrary') {
    const openedFile: ContentLibraryOpenedFile | null = yield select(
      selectContentLibraryOpenedFile
    );
    if (openedFile && CONTENT_BOARD_SUPPORTED_FILE_TYPES.includes(openedFile.type)) {
      const currentPage: number = yield select(selectContentLibraryOpenedFileCurrentPage);
      yield put(requestContentWhiteboardData({ id: openedFile.id, page: currentPage }));
    }
    return;
  }

  if (currentGridPanel === 'screenshare') {
    const selectedScreenshare: SelectedScreenshare | null = yield select(selectSelectedScreenshare);
    if (selectedScreenshare) {
      yield put(
        requestScreenshareWhiteboardData({
          feedId: selectedScreenshare.feedId,
          userId: selectedScreenshare.userId,
        })
      );
    }
  }
}
